export default __webpack_public_path__ + "static/media/bookmark-white.58cb82cc.svg";